"use strict";

/* global requestAnimationFrame */
var footerToggle = document.querySelectorAll('.footerLinkToggle');

var openLinkSections = function openLinkSections(toggle) {
  var sectionLinks = toggle.querySelector('.sectionLinks');
  var arrow = toggle.querySelector('.arrow');
  document.querySelectorAll('.footerLinkToggle.linkListOpen').forEach(function (otherToggle) {
    closeLinkSections(otherToggle);
  });
  requestAnimationFrame(function () {
    toggle.classList.add('linkListOpen');
    sectionLinks.style.height = "".concat(sectionLinks.scrollHeight, "px");
    arrow.style.transform = 'rotate(180deg)';
  });
};

var closeLinkSections = function closeLinkSections(toggle) {
  var sectionLinks = toggle.querySelector('.sectionLinks');
  var arrow = toggle.querySelector('.arrow');
  requestAnimationFrame(function () {
    toggle.classList.remove('linkListOpen');
    sectionLinks.style.removeProperty('height');
    arrow.style.removeProperty('transform');
  });
};

var toggleFooterLinkSection = function toggleFooterLinkSection(toggle) {
  var sectionLinks = toggle.querySelector('.sectionLinks');

  if (!sectionLinks.style.height || sectionLinks.style.height === '0px') {
    openLinkSections(toggle);
  } else {
    closeLinkSections(toggle);
  }
};

var initFooterLinks = function initFooterLinks() {
  footerToggle.forEach(function (toggle) {
    closeLinkSections(toggle);
  });
};

var initFooterLinksHandler = function initFooterLinksHandler() {
  footerToggle.forEach(function (toggle) {
    toggle.onclick = function () {
      if (window.innerWidth < 992) {
        toggleFooterLinkSection(toggle);
      }
    };
  });
};

var initYear = function initYear() {
  var date = new Date();
  document.getElementById('copyrightCurrentYear').innerHTML = date.getFullYear();
};

initYear();
initFooterLinks();
initFooterLinksHandler();

window.onresize = function () {
  initFooterLinks();
};